export default {
  documentTitle: {
    login: "Y 系统酒店端｜登录",
    dashboard: "Y 系统酒店端｜数据看板",
    post: "Y 系统酒店端｜帖子"
  },
  buttons: {
    logout: "退出系统",
    add: "新增",
    delete: "删除",
    reload: "重新加载",
    backTop: "回到顶部"
  },
  menus: {
    home: "首页",
    login: "登录",
    abnormal: "异常页面",
    fourZeroFour: "404",
    fourZeroOne: "403",
    hsFive: "500"
  },
  status: {
    loading: "加载中..."
  },
  login: {
    username: "账号",
    password: "密码",
    login: "登录",
    usernameReg: "请输入账号",
    passwordReg: "请输入密码",
    passwordRuleReg: "密码格式应为8-18位数字、字母、符号的任意两种组合",
    channelPh: "请选择渠道"
  }
};
